/**
 * ng-expertiza.ru
 *
 * @author      хз, кто автор, я доделывал.... delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */



const baseSelector    = `.accordion`;
const headerSelector  = `${baseSelector}__heading`;
const contentSelector = `${baseSelector}__content`;
const openStateClass  = `active`;

$.fn.accordion = function(obj) {
    $.each(this, function() {
        let active = (obj.active) ? obj.active - 1 : 0;
        let target = $.makeArray($(this).find(headerSelector));

        $(target[active]).addClass(openStateClass);
        $(target[active]).next(contentSelector).slideDown();

        $(target).click(function() {
            $(this).toggleClass(openStateClass).siblings().removeClass(openStateClass);
            $(this).next(contentSelector).slideToggle().siblings(contentSelector).slideUp();
        });
    });

    return false;
};
